import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Document} from '../model/Entities/Document';

@Injectable()
export class DocumentService extends ApiService<Document> {

    protected apiUrl = 'api/document';  // URL to web api

    protected getObjectType(): any {
        return Document;
    }
}



// WEBPACK FOOTER //
// /app/src/services/document.service.ts